import { DeviceType } from "@/types";
const deviceHelper = {
  isiOS(): boolean {
    const userAgent = window.navigator.userAgent.toLowerCase(),
      safari = /safari/.test(userAgent),
      ios = /iphone|ipod|ipad/.test(userAgent),
      ourapp = /iosapp/.test(userAgent); // ios 클라이언트 앱에서 커스텀 user agent 로 iosapp을 추가
    return ios && !safari && ourapp;
  },

  isAndroid(): boolean {
    const userAgent = window.navigator.userAgent.toLowerCase(),
      android = userAgent.indexOf("android") > -1,
      ourapp = /androidapp/.test(userAgent); // Android 클라이언트 앱에서 커스텀 user agent 로 androidapp을 추가
    return android && ourapp;
  },

  isNativeApp(): boolean {
    const userAgent = window.navigator.userAgent.toLowerCase();
    return /iosapp|androidapp/.test(userAgent);
  },

  getDeviceType(): DeviceType {
    const deviceWidth = document.documentElement.clientWidth;
    const deviceHeight = document.documentElement.clientHeight;
    if (deviceWidth <= 320 && deviceHeight <= 568) {
      return DeviceType.Xsmall;
    } else if (deviceWidth > 320 && deviceHeight <= 667) {
      return DeviceType.Small;
    } else if (
      deviceWidth > 320 &&
      deviceWidth < 375 &&
      deviceHeight > 667 &&
      deviceHeight <= 730
    ) {
      return DeviceType.Medium;
    } else if (deviceWidth > 320 && deviceWidth < 400 && deviceHeight > 667) {
      return DeviceType.Large;
    }
    return DeviceType.Xlarge;
  },

  isMobile(): boolean {
    const userAgent = window.navigator.userAgent.toLowerCase();
    const mobile =
      /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        userAgent
      );
    return !!mobile;
  },

  isSafari(): boolean {
    const userAgent = window.navigator.userAgent.toLowerCase(),
      // crios: iOS 크롬
      safari =
        /safari/.test(userAgent) && !/chrome|crios|android/.test(userAgent);
    return safari;
  },
};
export default deviceHelper;
